<template>
  <div class="alertcontent" v-if="dialogVisible">
    <div class="alertcontentdiv">
      <div class="alertcontentdiv_head">
        <p>{{dlgTitle}}</p>
        <div>
          <i class="el-icon-close" @click="cancel"></i>
        </div>
      </div>
      <div class="alertcontentdiv_params">
        <div class="content-params">
          <!-- 组织名称 -->
          <div class="params">
            <label class="custom_label">组织名称：</label>
            <span style="min-width:210px"><el-input placeholder="请输入组织名称" v-model="organizeName"></el-input></span>
          </div>
          <div class="params">
            <label class="custom_label">组织编码：</label>
            <span style="min-width:210px"><el-input placeholder="请输入组织编码"  v-model="organizeCode"></el-input></span>
          </div>
          <span class="orgBtn btn-font" @click="searchData()"><i class="iconfont icon-chaxun"></i><label>搜索</label></span>
        </div>
      </div>
      <div class="alertcontentdiv_table">
        	<el-table ref="multipleTable" :data="dataList"
            :highlight-current-row="true"
            @row-click="rowClick" tooltip-effect="dark" style="width: 100%"  border height=100%>
            <!--<div  slot="empty" v-if="emptyErrorText" :class="loading?'':'empty-err'">{{loading?'暂无数据':emptyErrorText}}</div>-->
                <el-table-column label=""  fixed align="center" width='50'>
                    <template slot-scope="props">
                        <span class="tran_box">
                           <el-radio v-model="selectId" :label="props.row[idField]">&nbsp;</el-radio>
                       </span>
                    </template>
                </el-table-column>
                <el-table-column label="序号" center align="center" width='50'> 
                    <template slot-scope="scope">{{ scope.$index+1+(pageNo-1)*pageSize }}</template>
                </el-table-column>

                <el-table-column v-for="(item,index) in tableColumns" :key="index" :prop="item.name" align="center" :label="item.label" show-overflow-tooltip center>
                    <template slot-scope="scope">{{item.formatter ? item.formatter(scope.row[item.name], scope.row, index) : scope.row[item.name]}}</template>
                </el-table-column>
            </el-table>
      </div>
      <div class="alertcontentdiv_page">
          <div>
            总共<font style="color:#409EFF">{{totalRows}}</font>条记录
          </div>
          <el-pagination layout="prev, pager, next" :total="totalRows"  :current-page="pageNo" :page-size="pageSize" @current-change="currentChangeType">
          </el-pagination>
      </div>
      <div class="alertcontentdiv_buttom">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// import * as Api from '@/api/promotion.js'
import { methodPost } from '../../api/request'
function requried(column) {
  throw new Error(`缺少参数[${column}]`)
}

export default {
  name: 'SearchDialog',
  props: {
    modalTitle: String,
    data: Array,
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      show: false,
      loading: false,
      organizeCode: '',
      organizeName: '',
      dlgTitle: '',
      selectId: '', // 选中的id
      selectedItem: {},
      pageNo: 1, // 当前页码
      pageSize: 20, // 每页多少条数据
      totalRows: 0, // 总共多少数据
      tableColumns: [],
      dataList: [ // 数据源
      ],
      emptyErrorText: ''
    }
  },
  created() {
  },
  methods: {
    async open({
      dlgTitle,
      url = requried('url'),
      selectId,
      pageNo = 1,
      pageSize = 20,
      emptyMessage = requried('emptyMessage'),
      tableColumns = requried('tableColumns'),
      idField = 'id'
    }) {
      this.organizeCode = '';
      this.organizeName = '';
      this.show = true;
      this.dlgTitle = dlgTitle;
      this.url = url;
      this.selectId = selectId;
      this.pageNo = pageNo;
      this.pageSize = pageSize;
      this.tableColumns = tableColumns;
      this.idField = idField;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      return new Promise((resolve, reject) => {
        this.getData(params).then(() => {
          this.selectedItem = this.dataList.find(o => o[this.idField] === this.selectId) || {};
          this.resolve = resolve;
          this.reject = reject;
        })
      })
    },
    getData(params) {
      this.loading = true
      return methodPost(this.url, {
        ...params
      }).then(res => {
        this.loading = false
        const { code, data, message } = res
        if (code !== 0) {
          this.$message(message)
        } else {
          if (data.data.length > 0) {
            this.dataList = data.data.map(o => {
              const item = {
                ...o
              }
              this.tableColumns.forEach((c, index) => {
                if (c.translater) {
                  item[c.name] = c.translater(item[c.name], item, index)
                }
              })
              return item;
            })
            this.totalRows = data.totalRows
          } else {
            this.dataList = []
            this.totalRows = 0
          }
        }
      })
    },
    rowClick(row, column, cell, event) {
      this.selectId = row[this.idField];
      this.selectedItem = row;
    },
    currentChangeType(pageNo) {
      this.pageNo = pageNo
      this.searchData(true)
    },
    confirm() {
      if (!this.selectedItem[this.idField]) {
        this.$message.error(this.emptyMessage)
      } else {
        this.resolve(this.selectedItem);
      }
    },
    searchData() {
      let params = {}
      params = {
        organizeCode: this.organizeCode,
        organizeName: this.organizeName,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.getData(params)
    },
    cancel() {
      this.$emit("close");
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
  .empty-err{
    text-align: center;
    color: red
  }
.alertcontent {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index:9;
  .alertcontentdiv {
    position: absolute;
    left: calc(50% + 90px);
    top: 50%;
    transform: translate(-50%, -50%);
    width: 900px;
    height: 660px;
    padding: 20px;
    // padding-top: 0;
    background: #fff;
    display: flex;
    flex-direction: column;
    .el-icon-close {
      font-size: 20px;
      cursor: pointer;
    }
    .alertcontentdiv_head {
      display: flex;
      align-items: center;
      position: relative;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      p {
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-weight: bold;
      }
      &>div {
        position: absolute;
        right: 10px;
      }
    }
    
    .alertcontentdiv_table {
      flex:1;
      overflow-y: auto;
    }
    .alertcontentdiv_page {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      div:nth-of-type(1) {
        font-size: 14px;
      }
      .el-pagination {
        float: right;
      }
    }
    .alertcontentdiv_buttom {
      height: 32px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/organizationManagement/tabel-dialog.vue